<ion-header [translucent]="true" class="ninja">
  <ion-toolbar class="thin-toolbar" mode="ios">
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" [forceOverscroll]="false">
  <section class="old-style">
    <div class="tr-public-container tr-start-height">
      <div class="h-100 w-100 d-flex flex-column">
        <div class="pt-5 pb-4">
          <a href="https://{{appVariables.WHITELABEL_LINK}}">
            <img class="d-block mx-auto logo" src="assets/img/{{appVariables.WHITELABEL_LOGO}}" [alt]="appVariables.WHITELABEL_BRAND">
          </a>
        </div>

        <div id="verificationForm" class="tr-start-box col-xs-12 col-sm-8 col-md-6 col-lg-4 offset-sm-2 offset-md-3 offset-lg-4">
          <div class="p-3" *ngIf="accountId && accountId !== ''">
            <h2 class="mb-3 into">Please confirm your email address</h2>
            <p>Check your email for the verification link we sent when you signed up.</p>
            <p>You may also get a new verification link by clicking below.</p>
            <p>If you need to update your email, log in and go to <a class="link" routerLink="/settings/account/profile">Settings > Profile</a>.</p>
            <div class="text-center">
              <button
                (click)="resend()"
                [disabled]="sending"
                class="btn btn-info btn-lg mb-2"
                angularticsCategory="auth"
                angulartics2On="click"
                angularticsAction="Resend Verification"
              >Resend Verification</button>
            </div>
          </div>
          <div class="p-3" *ngIf="!accountId">
            <h2 class="mb-3">Unknown user. Please <a routerLink="/login">login</a> and then click the verification link from the status bar.</h2>
          </div>
        </div>
      </div>
    </div>
  </section>
</ion-content>
